import { RecurrenceOptions } from 'src/graphql/entities/signal-oncall-schedule/signal-oncall-schedule.types';

export type CalendarView = 'week' | 'day' | 'agenda';
export const CALENDAR_VIEWS: readonly CalendarView[] = ['week', 'day', 'agenda'];
export type CalendarLayoutMode = 'desktop' | 'mobile';
export const DESKTOP_CALENDAR_VIEWS: readonly CalendarView[] = ['week', 'day', 'agenda'];
export const MOBILE_CALENDAR_VIEWS: readonly CalendarView[] = ['day', 'agenda'];
export const DEFAULT_DESKTOP_CALENDAR_VIEW: CalendarView = 'week';
export const DEFAULT_MOBILE_CALENDAR_VIEW: CalendarView = 'day';

export function isCalendarView(value: unknown): value is CalendarView {
  return typeof value === 'string' && CALENDAR_VIEWS.includes(value as CalendarView);
}

export interface CalendarEventObject {
  id: string;
  start: Date;
  end: Date;
  until?: Date;
  recurrence: RecurrenceOptions;
  primaryAgentId: string;
  secondaryAgentId?: string;
  title: React.ReactNode;
  tooltip: string;
  isTemporary?: boolean;
}
